/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_BRANCH_TYPES, GET_BRANCH_TYPES, SET_BRANCH_TYPES } from 'src/actions/branchTypesActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const branchTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_BRANCH_TYPES: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_BRANCH_TYPES: {
      const { branchTypes, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = branchTypes;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    case SET_BRANCH_TYPES: {
      const { branchTypes } = action.payload;

      return produce(state, (draft) => {
        draft.items = branchTypes;
      });
    }

    default: {
      return state;
    }
  }
};

export default branchTypeReducer;
